import React from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import SearchResultPage from '../components/babyName/SearchResultPage'
import NotFound from './NotFound'

const BabyNameSearch = props => {
  // there is 1 limitation here...
  // when user browse to this page manually by enter this url '/baby-name/search/a%25b' on their browser
  // it will match with this path pattern '/baby-name/search/:name'
  // but our `props.match.params.name` that we got here is 'a%b' (not 'a%25b')
  // when we try to decode string 'a%b' with 'decodeURIComponent' it will fail due to malformed URI
  // console.log(get(props, 'match.params.name'))
  const name = decodeURIComponent(get(props, 'match.params.name'))

  if (!name) return <NotFound />

  const params = new URLSearchParams(get(props, 'location.search'))
  const sex = params.get('sex') === 'boy' ? 'M' : params.get('sex') === 'girl' ? 'F' : null
  const neutral =
    params.get('neutral') === 'true' ? true : params.get('neutral') === 'false' ? false : null

  return <SearchResultPage text={name} sex={sex} isNeutral={neutral} />
}

BabyNameSearch.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default BabyNameSearch
